/**
 * Retoques de texto del widget de reseñas (Judge.me) en el PDP.
 *
 * Judge.me imprime el promedio como "5.00 de 5". Con calificación entera se
 * lee mejor "5 de 5"; con decimales se conserva el valor ("4.95 de 5").
 * No se puede hacer con CSS porque es contenido de texto, y el widget se
 * repinta al filtrar u ordenar — por eso el MutationObserver.
 */
(function () {
  function formatear() {
    var el = document.querySelector('.jdgm-rev-widg__summary-average');
    if (!el) return;
    var txt = (el.textContent || '').trim();
    var m = txt.match(/^([\d.,]+)\s*(?:de|of)\s*5$/i);
    if (!m) return;
    var n = parseFloat(m[1].replace(',', '.'));
    if (!isFinite(n)) return;
    // Entero → "5"; con decimales → sin ceros de relleno ("4.95", "4.9")
    var limpio = n % 1 === 0 ? String(n) : String(parseFloat(n.toFixed(2)));
    var nuevo = limpio + ' de 5';
    if (txt !== nuevo) el.textContent = nuevo;
  }

  function arrancar() {
    formatear();
    var widget = document.querySelector('.jdgm-rev-widg');
    if (widget && typeof MutationObserver === 'function') {
      new MutationObserver(formatear).observe(widget, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
  window.addEventListener('load', formatear);
})();
